// ── DnD ID Utilities ──
// Centralized ID generation and parsing for drag-and-drop operations

export const dndIds = {
  // ── ID generators ──
  sidebar: 'sidebar',
  sidebarItem: (poiId: string) => `sidebar-${poiId}`,
  dayColumn: (dayId: string) => `day-column-${dayId}`,
  dayContainer: (dayId: string) => `day-container-${dayId}`,
  dayItem: (dayId: string, poiId: string) => `${dayId}:${poiId}`,

  // ── Parsers ──
  parseDayItem: (id: string): { dayId: string; poiId: string } => {
    const [dayId, poiId] = id.split(':');
    return { dayId, poiId };
  },

  parseSidebarItem: (id: string): string => id.replace('sidebar-', ''),

  parseDayColumn: (id: string): string => id.replace('day-column-', ''),

  parseDayContainer: (id: string): string => id.replace('day-container-', ''),

  // ── Type guards ──
  isDayItem: (id: string): boolean => id.includes(':'),
  isSidebarItem: (id: string): boolean => id.startsWith('sidebar-'),
  isDayColumn: (id: string): boolean => id.startsWith('day-column-'),
  isDayContainer: (id: string): boolean => id.startsWith('day-container-'),
};
